import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class ForEachKeyStructuredStorageHelper extends StructuredStorageBaseHelper {
    constructor({ each, ...rest }) {
        super(rest);
        this.each = each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.forEachStructuredStorage({
            type: this.type,
            each: (innerOptions) => {
                sb.emitOp(node, 'NIP');
                this.each(sb.noPushValueOptions(innerOptions));
            },
        }));
    }
}

//# sourceMappingURL=ForEachKeyStructuredStorageHelper.js.map
